import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type Params = {
  '*': string;
  app: string;
  page: string;
  lng: string;
};

export const LANGUAGE_REDIRECT_KEY = 'LanguageredirectKey';

type LanguageRedirectGenericProps = {
  forcedLanguage?: string;
};

export function LanguageRedirectGeneric({ forcedLanguage }: LanguageRedirectGenericProps) {
  const { app, page, lng: routeLanguage, '*': remainder } = useParams<Params>();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lng = forcedLanguage ?? routeLanguage;

  useEffect(() => {
    if (!lng) return;

    const redirectPath = (() => {
      if (typeof remainder === 'string') {
        return remainder ? `/${remainder}` : '/';
      }

      if (app && page) {
        return `/${app}/${page}`;
      }

      return null;
    })();

    if (!redirectPath) return;

    const supported = Array.isArray(i18n.options.supportedLngs)
      ? (i18n.options.supportedLngs as readonly string[])
      : [];

    if (supported.includes(lng)) {
      i18n.changeLanguage(lng);
    }
    navigate(redirectPath, { replace: true });
  }, [app, i18n, lng, navigate, page, remainder]);

  return null;
}
